import moment from 'moment';

import { DISPLAY_DATE_FORMAT } from '@/consts';

import {
  SET_CONTRACT,
  SET_CLIENT,
} from './types';

export const INIT_STATE = {
  contract: {
    id: null,
    mifosId: null,
    order: null,
    active: false,
    status: null,
    dueDate: null,
    asset: {
      description: null,
      fullDescriptionVi: null,
      meta: {},
    },
    assetType: {},
    maturesDate: moment().format(DISPLAY_DATE_FORMAT),
    oldTotalRepayment: 0,
    oldTotalWaived: 0,
    oldPenaltyChargesCharged: 0,
    oldPenalty: 0,
    oldDueDate: null,
    oldInterestAmount: 0,
    oldProductRepayEvery: 0,
    oldApprovedAmount: 0,
    product: {},
    storage: {},
    source: null,
    diffAmount: 0,
    penalty: 0,
    specialInterestValue: 0,
    interestAmount: 0,
    requiredAmount: 0,
    proposedAmount: 0,
    principalAmount: 0,
    promotionAmount: 0,
    approvedAmount: 0,
    warehousingFee: 0,
    payAmount: 0,
    receivedAmount: 0,
  },
  client: {
    id: null,
    mifosId: null,
    name: null,
    primaryPhone: null,
    alternativePhone: null,
    dateOfBirth: moment().format(DISPLAY_DATE_FORMAT),
    nationalId: null,
    address: null,
    district: null,
    city: null,
    note: null,
  }
};

const mutations = {
  [SET_CONTRACT](state, contract) {
    state.contract = {
      ...state.contract,
      ...contract,
    };
  },
  [SET_CLIENT](state, client) {
    state.client = {
      ...state.client,
      ...client,
    };
  },
};

export default mutations;
